import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppShell } from './components/layout/AppShell';
import { ProjectSummary } from './pages/ProjectSummary';
import { Capacity } from './pages/Capacity';
import { AtRisk } from './pages/AtRisk';
import { ReportsPage } from './pages/ReportsPage';
import { Placeholder } from './pages/Placeholder';
import { WebSocketProvider } from './hooks/useWebSocket';

// Configure React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// WebSocket channels for dashboard (leadership view)
const WS_CHANNELS = ['schedule'];

/**
 * Main application component with routing and providers.
 */
export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <WebSocketProvider channels={WS_CHANNELS}>
          <BrowserRouter>
            <Routes>
              <Route element={<AppShell />}>
                <Route index element={<ProjectSummary />} />
                <Route path="capacity" element={<Capacity />} />
                <Route path="at-risk" element={<AtRisk />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route
                  path="timeline"
                  element={
                    <Placeholder
                      title="Timeline View"
                      description="Gantt-style overview of all project schedules."
                    />
                  }
                />
                <Route
                  path="resources"
                  element={
                    <Placeholder
                      title="Resource Utilization"
                      description="Heatmap showing utilization by person and skill."
                    />
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </WebSocketProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
